import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnInit } from '@angular/core';
import { FAQ, TrustCenterEventService, TrustCenterFacadeService, TrustResourceEventDataProperty } from '@anecdotes/shared-trust-center';
import { TrustCenterModalService } from '../../../../services/trustcenter-modals/trustcenter-modals.service';
import { firstValueFrom, Observable, shareReplay } from 'rxjs';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqComponent implements OnInit {
  @HostBinding('attr.role')
  private readonly role = 'button';

  @Input()
  faq: FAQ;

  @Input()
  isEditing = false;

  isPreviewMode$: Observable<boolean>;
  
  get isHidden(): boolean {
    return this.faq ? !this.faq.is_visible : false;
  }

  get isExpandable(): boolean {
    return this.faq ? !this.isEditing : false;
  }

  get isExpanded(): boolean {
    return this.faq ? this.isEditing : false;
  }

  constructor(
    private readonly trustCenterModalService: TrustCenterModalService,
    private readonly trustCenterEventService: TrustCenterEventService,
    private readonly trustCenterFacadeService: TrustCenterFacadeService,
  ) {}

  ngOnInit(): void {
    this.isPreviewMode$ = this.trustCenterFacadeService.isPreviewMode().pipe(shareReplay({ bufferSize: 1, refCount: true }));
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.faqs.${key}`;
  }

  @HostListener('click')
  private openFaq(): void {
    if (this.isEditing) {
      this.trustCenterModalService.openFaqSidePanel(this.faq);
    }
  }

  async faqHeaderClicked(expanded: boolean): Promise<void> {
    const isPreviewMode = await firstValueFrom(this.isPreviewMode$);

    if (expanded && !this.isEditing && !isPreviewMode) {
      const companyName = await firstValueFrom(this.trustCenterFacadeService.getName());
      this.trustCenterEventService.trackClickOnResourceItem(TrustResourceEventDataProperty.Faqs, this.faq.id?.toString(), companyName);
    }
  }
}
